import { render, staticRenderFns } from "./university-campaign-form.vue?vue&type=template&id=9b0e5260&scoped=true&"
import script from "./university-campaign-form.vue?vue&type=script&lang=js&"
export * from "./university-campaign-form.vue?vue&type=script&lang=js&"
import style0 from "./university-campaign-form.vue?vue&type=style&index=0&id=9b0e5260&scoped=true&lang=css&"
import style1 from "./university-campaign-form.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0e5260",
  null
  
)

export default component.exports